// extracted by mini-css-extract-plugin
export var inlineLink = "_44-0";
export var inlineLinkButton = "_44-1";